export const SALES_FEATURES = {
  tracking: {
    id: 'tracking',
    label: {
      long: 'label.SALES_TRACKING',
      short: 'label.SALES_TRACKING'
    }
  },
  autobcc: {
    id: 'autobcc',
    label: {
      long: 'label.AUTO_BCC',
      short: 'label.AUTO_BCC'
    }
  }
};
